import {
    PopupComponent as SourcePopupComponent,
} from 'SourceComponent/Popup/Popup.component';
import React from 'react';
import './Popup.override.style';
import ClickOutside from '@scandipwa/scandipwa/src/component/ClickOutside';

export class PopupComponent extends SourcePopupComponent {
    renderContent() {
        const { children, contentMix, id } = this.props;
        const isVisible = this.getIsVisible();

        if (!isVisible && id !== "FreeGiftOption") {
            return null;
        }

        if (id === "FreeGiftOption") {
            return (
                <div className="Popup-Content">
                    {children}
                </div>
            )
        }

        return (
            <ClickOutside onClick={this.handleClickOutside}>
                <div className="Popup-Content">
                    <header className="Popup-Header">
                        {this.renderTitle()}
                        {this.renderCloseButton()}
                    </header>
                    {this.renderNotifications()}
                    {children}
                </div>
            </ClickOutside>
        );
    }
}

export default PopupComponent;
